import React from 'react';
import { createPortal } from 'react-dom';
import { H2, BodyText } from '@citygross/typography';
import { ModalOverlay, ModalContainer, ModalHeaderContainer, ModalHeader, CloseButtonWrapper, ChildrenWrapper, FooterWrapper } from './Modal.styles.js';
import { Icons } from '@citygross/icons';
import { theme } from '@citygross/design-tokens';
import { Spacer } from '../Spacer/Spacer.js';

var Modal = function Modal(_a) {
  var _b;

  var onBackdropClick = _a.onBackdropClick,
      children = _a.children,
      title = _a.title,
      subTitle = _a.subTitle,
      _c = _a.hideCancel,
      hideCancel = _c === void 0 ? true : _c,
      isConfirm = _a.isConfirm,
      maxWidth = _a.maxWidth,
      _d = _a.background,
      background = _d === void 0 ? (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.white : _d,
      _e = _a.querySelector,
      querySelector = _e === void 0 ? '#root' : _e,
      footer = _a.footer;
  var domSafe = typeof document !== 'undefined';
  return domSafe ? createPortal(React.createElement(ModalOverlay, {
    onClick: onBackdropClick
  }, React.createElement(ModalContainer, {
    isConfirm: isConfirm || false,
    maxWidth: maxWidth,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    background: background
  }, title && React.createElement(React.Fragment, null, React.createElement(ModalHeaderContainer, null, React.createElement(ModalHeader, null, React.createElement(H2, null, title), !hideCancel && React.createElement(CloseButtonWrapper, {
    onClick: onBackdropClick
  }, React.createElement(Icons.Cross, null))), React.createElement(BodyText, null, subTitle))), children && React.createElement(React.Fragment, null, React.createElement(ChildrenWrapper, null, children)), footer && React.createElement(React.Fragment, null, React.createElement(Spacer, null), React.createElement(FooterWrapper, null, footer)))), document.querySelector(querySelector) || document.body) : null;
};

export { Modal };